<template>
  <v-app>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous">
    <Header :auth="auth" :authenticated="authenticated" />
    <div id='appbody'>
        <router-view :auth="auth" :authenticated="authenticated" :qualified_profile="qualified_profile" />
    </div>
  </v-app>
</template>

<script>
//import AuthService from '@/Auth/AuthService';
import AuthService from '@/Auth/AuthTaptags';
import Header from '@/components/Header';
import {mapState} from 'vuex';
const auth = new AuthService();

export default {
  components: {Header},
  name: 'app',
  data() {
    return {
      auth,
      authenticated: auth.authenticated,
      qualified_profile: auth.qualified_profile,
      authsms_phone: '',
      authsms_code: '',
      phone: '',
      password: '',
    };
  },
  created() {
    var that = this;
    auth.authNotifier.on('authChange', authState => {
      console.log('app got authChange', authState);
      that.$data.authenticated = authState.authenticated;
      that.$data.qualified_profile = authState.qualified_profile;
      this.$store.dispatch('forceProfile', {data: authState.myprofile});
      if (that.$data.authenticated) {
        that.$store.dispatch('loadEvents');
        that.$store.dispatch('loadAttendees');
      }
    });
    auth.renewSession();
  },
  computed: {
    ...mapState(['myprofile']),
  },
  methods: {
    login(phone, password) {
      auth.login(phone, password);
    },
    logout() {
      auth.logout();
    },
    register() {
      auth.register(this.authsms_phone);
    },
    check_session() {
      auth.check_session();
    },
    authsms_verify() {
      auth.authsms_verify(this.authsms_phone, this.authsms_code);
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#appbody {
  padding-top: 53px;
}
</style>
